import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ViewerRoute — redirects Tender Viewers away from write-restricted paths.
 *
 * Wrap any route that a Tender Viewer must not access directly:
 *   <Route path="NewTender" element={<ViewerRoute><NewTender /></ViewerRoute>} />
 *
 * Viewers are redirected to /AdvanceTender (their read-only landing page).
 * All other authenticated users pass through unchanged.
 */
export function ViewerRoute({ children }) {
  const { userType } = useAuth();
  if (userType?.isViewer) {
    return <Navigate to="/AdvanceTender" replace />;
  }
  return children;
}
